import {
  fetchUser,
  fetchPollGames,
  fetchQuestion,
  fetchRoom,
  fetchQuiz,
  fetchConversations,
  fetchCommunities,
  fetchCommunitiesPosts,
  fetchPost,
} from '../api'

export default {
  FETCH_USER: async ({ commit, state }, { handle }) => {
    return state.users[handle]
      ? state.users[handle]
      : await fetchUser(handle).then(user => commit('SET_USER', { handle, user }))
  },
  SET_ANSWER_CODE: async ({ commit, state }, data) => {
    return commit('SET_ANSWER_CODE', data)
  },
  SET_PROFILE_MESSAGE_CODE: async ({ commit, state }, data) => {
    return commit('SET_PROFILE_MESSAGE_CODE', data)
  },
  POLL_GAME: async ({ commit, state }, { code }) => {
    return state.pollGames[code]
      ? state.pollGames[code]
      : await fetchPollGames(code).then(pollGames => commit('SET_POLL_GAME', { code, pollGames }))
  },
  FETCH_QUESTION: async ({ commit, state }, { qid, handle }) => {
    return state.questions[qid]
      ? state.questions[qid]
      : await fetchQuestion(qid, handle).then(question => commit('SET_QUESTION', { qid, handle, question }))
  },
  FETCH_ROOM: async ({ commit, state }, { rid, handle }) => {
    return state.rooms[rid]
      ? state.rooms[rid]
      : await fetchRoom(rid, handle).then(room => commit('SET_ROOM', { rid, handle, room }))
  },
  FETCH_QUIZ: async ({ commit, state }, { qid, handle }) => {
    return state.quizzes[qid]
      ? state.quizzes[qid]
      : await fetchQuiz(qid, handle).then(quiz => commit('SET_QUIZ', { qid, handle, quiz }))
  },
  SET_POLL_ANSWERED: async ({ commit }) => {
    return commit('SET_POLL_ANSWERED')
  },
  FETCH_CONVERSATIONS: async ({commit, state}, { id }) => {
    return state.conversations[id]
      ? state.conversations[id]
      : await fetchConversations(id).then(conversations => commit('SET_CONVERSATIONS', { id, conversations }))
  },
  FETCH_COMMUNITIES: async ({commit, state}, { id }) => {
    return state.communities[id]
      ? state.communities[id]
      : await fetchCommunities(id).then(communities => commit('SET_COMMUNITIES', { id, communities }))
  },
  
  FETCH_COMMUNITIES_POSTS: async ({commit, state}, { cid, pid }) => {
    return state.communityPosts[pid]
      ? state.communityPosts[pid]
      : await fetchCommunitiesPosts(cid, pid).then(posts => commit('SET_COMMUNITIES_POSTS', { pid, posts }))
  },

  FETCH_POST: async ({commit, state}, { pid }) => {
    return state.posts[pid]
      ? state.posts[pid]
      : await fetchPost(pid).then(post => commit('SET_POST', { pid, post }))
  },
  
}



// WEBPACK FOOTER //
// src/store/actions.js